<template>
  <div id="app">
    <div class="site-top-bar">
      <div class="top-bar-links">
        <span
          v-for="(link, index) in topBarLinks"
          :key="link.label"
          class="top-bar-link"
        >
          <router-link v-if="link.route" :to="link.route">{{ link.label }}</router-link>
          <span v-else>{{ link.label }}</span>
          <span v-if="index < topBarLinks.length - 1" class="top-bar-divider">｜</span>
        </span>
      </div>
      <img class="top-bar-logo" :src="topLogo" alt="中国社会科学网" />
    </div>
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      topBarLinks: [
        { label: '社科网首页', route: '/lanhu_shouye' },
        { label: '论坛' },
        { label: '人文社区' },
        { label: '客户端' },
        { label: '官方微博' },
        { label: '报刊投稿' },
        { label: '邮箱' }
      ],
      topLogo: require('./views/lanhu_shouye/assets/img/logo.png')
    };
  }
};
</script>

<style lang="css" src="./assets/common.css"></style>
